"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ContainerBox_1 = require("../../atoms/ContainerBox/ContainerBox");
var Logo_1 = require("../../atoms/Logo/Logo");
exports.Vista = function () { return (
// TODO: Add background graphics options etc....
react_1.default.createElement(ContainerBox_1.ContainerBox, null,
    react_1.default.createElement(Logo_1.Logo, { logo: Logo_1.LOGOS.RUNESCAPE }))); };
